import { store } from '@/state/store';
import { DTO__workspace_user } from '@shared/dto/+workspace/workspace_user/DTO__workspace_user';
import dayjs from 'dayjs';

export function get_sorted_current_workspace_users() {
  const { workspace_current, current_workspace_user, all_workspaces_users_map } = store.getState().slice_workspace;

  const users_from_this_workspace = all_workspaces_users_map.get_or_assert(workspace_current._id, { context: 'users_from_this_workspace' });

  const users = Array.from(users_from_this_workspace.values());
  users.sort(DTO__workspace_user.sort_by_name);

  const index = users.findIndex(user => user.user_id === current_workspace_user.user_id);
  if (index > 0) {
    const [matchedUser] = users.splice(index, 1);
    users.unshift(matchedUser);
  }

  return users;
}

export function get_workspace_user() {
  const { slice_workspace, slice_user } = store.getState();

  let out = DTO__workspace_user.CREATE_STUB();

  if (!slice_workspace.is_all_data_loaded) return out;
  if (!slice_user.is_authorized) return out;

  let workspace_current = slice_workspace.workspace_current;
  let { user_id } = slice_user;
  let workspace_id = workspace_current._id;

  let users_map = slice_workspace.all_workspaces_users_map.get_or_assert(workspace_id, { context: 'users_map' });

  out = users_map.get_value_or_default(user_id, DTO__workspace_user.CREATE_STUB({ user_id, workspace_id }));

  return out;
}

export function get_auto_reset_date(): string {
  return dayjs().add(1, 'month').startOf('month').format('YYYY.MM.DD');
}
